// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-dashboard {
    padding: 20px;
}

/* Title with back button */
.title-with-back {
    display: flex;
    align-items: center;
    gap: 12px;
}

.back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #666;
}

.back-button:hover {
    background: #f0f0f0;
    border-color: #007bff;
    color: #007bff;
}

.back-button i {
    font-size: 18px;
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.time-range-selector button {
    margin-left: 10px;
    padding: 8px 16px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 4px;
    cursor: pointer;
}

.time-range-selector button.active {
    background: #007bff;
    color: white;
    border-color: #007bff;
}

/* Metrics Grid */
.metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.metric-card {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.metric-card h3 {
    margin: 0 0 10px 0;
    font-size: 14px;
    color: #666;
    text-transform: uppercase;
}

.metric-value {
    font-size: 36px;
    font-weight: bold;
    margin: 10px 0;
}

.metric-value.positive {
    color: #4CAF50;
}

.metric-value.negative {
    color: #F44336;
}

.metric-value.warning {
    color: #FF9800;
}

.metric-label {
    font-size: 12px;
    color: #999;
}

/* Charts */
.chart-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.chart-card {
    min-height: 350px;
}

.chart-card h3 {
    margin-top: 0;
}

/* Agent Performance */
.agent-performance-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

/* Agent Type Selector */
.agent-selector {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
}

.agent-selector-btn {
    padding: 10px 20px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
}

.agent-selector-btn:hover {
    background: #f0f0f0;
    border-color: #007bff;
}

.agent-selector-btn.active {
    background: #007bff;
    color: white;
    border-color: #007bff;
}

.agent-card {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 6px;
    border-left: 4px solid #007bff;
}

.agent-card.no-data {
    background: #f8f9fa;
    border-left-color: #ccc;
}

.agent-card.no-data .no-data-message {
    color: #888;
    text-align: center;
    padding: 20px 0;
}

.agent-card h4 {
    margin: 0 0 15px 0;
    text-transform: capitalize;
}

.agent-stats .stat {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
}

.stat-label {
    color: #666;
}

.stat-value {
    font-weight: bold;
}

.stat-value.positive {
    color: #4CAF50;
}

.stat-value.negative {
    color: #F44336;
}

.stat-value.warning {
    color: #FF9800;
}

/* Social Stats */
.social-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

.stat-item {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.stat-item .label {
    font-size: 14px;
    color: #666;
}

.stat-item .value {
    font-size: 24px;
    font-weight: bold;
}

.stat-item .value.positive {
    color: #4CAF50;
}

.stat-item .value.negative {
    color: #F44336;
}

/* Daily Trends */
.daily-trends {
    margin-top: 20px;
}

.trend-row {
    display: grid;
    grid-template-columns: 120px 200px 1fr;
    gap: 15px;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
}

.trend-row:last-child {
    border-bottom: none;
}

.trend-row .date {
    font-weight: 500;
}

.trend-metrics {
    display: flex;
    gap: 10px;
}

.trend-metrics span {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
}

.trend-metrics .positive {
    background: #E8F5E9;
    color: #2E7D32;
}

.trend-metrics .neutral {
    background: #FFF9C4;
    color: #F57F17;
}

.trend-metrics .negative {
    background: #FFEBEE;
    color: #C62828;
}

.trend-metrics .escalations {
    background: #FFF3E0;
    color: #E65100;
}

.trend-bar {
    height: 20px;
    display: flex;
    border-radius: 4px;
    overflow: hidden;
}

.bar-segment {
    height: 100%;
}

.bar-segment.positive {
    background: #4CAF50;
}

.bar-segment.neutral {
    background: #FFC107;
}

.bar-segment.negative {
    background: #F44336;
}

/* Loading & Error States */
.loading,
.error {
    text-align: center;
    padding: 40px;
    font-size: 18px;
}

.error {
    color: #F44336;
}

/* Agent Logs Section */
.agent-logs-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.agent-logs-section h4 {
    margin-bottom: 15px;
    text-transform: capitalize;
}

.no-logs {
    text-align: center;
    color: #999;
    padding: 20px;
}

/* Conversation Cards */
.conversation-card {
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
    border: 1px solid #e0e0e0;
}

.conversation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    cursor: pointer;
    transition: background 0.2s;
}

.conversation-header:hover {
    background: #e9ecef;
}

.conversation-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.contact-name {
    font-weight: bold;
    font-size: 15px;
}

.platform-badge {
    background: #007bff;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    text-transform: uppercase;
}

.sentiment-badge {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: bold;
}

.sentiment-badge.positive {
    background: #E8F5E9;
    color: #2E7D32;
}

.sentiment-badge.neutral {
    background: #FFF9C4;
    color: #F57F17;
}

.sentiment-badge.negative {
    background: #FFEBEE;
    color: #C62828;
}

.sentiment-badge.mixed {
    background: #F3E5F5;
    color: #7B1FA2;
}

.message-count {
    color: #666;
    font-size: 13px;
}

.conversation-meta {
    display: flex;
    align-items: center;
    gap: 10px;
}

.last-message-time {
    color: #888;
    font-size: 12px;
}

.escalated-badge {
    background: #FFF3E0;
    color: #E65100;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
}

.expand-icon {
    color: #888;
    font-size: 12px;
}

/* Messages Container */
.messages-container {
    padding: 15px;
    background: white;
    border-top: 1px solid #e0e0e0;
    max-height: 400px;
    overflow-y: auto;
}

.message {
    margin-bottom: 12px;
    padding: 10px 15px;
    border-radius: 8px;
    max-width: 85%;
}

.message.inbound {
    background: #e3f2fd;
    margin-right: auto;
    border-bottom-left-radius: 4px;
}

.message.outbound {
    background: #f0f0f0;
    margin-left: auto;
    border-bottom-right-radius: 4px;
}

.message-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
    font-size: 12px;
}

.message-direction {
    font-weight: bold;
}

.message-time {
    color: #888;
}

.sentiment-mini {
    padding: 1px 6px;
    border-radius: 8px;
    font-size: 10px;
}

.sentiment-mini.positive {
    background: #c8e6c9;
    color: #2E7D32;
}

.sentiment-mini.neutral {
    background: #fff9c4;
    color: #F57F17;
}

.sentiment-mini.negative {
    background: #ffcdd2;
    color: #C62828;
}

.message-text {
    font-size: 14px;
    line-height: 1.4;
    word-wrap: break-word;
}

.response-time {
    font-size: 11px;
    color: #888;
    margin-top: 5px;
}

/* Selected Agent Card */
.agent-card.selected {
    border-left-color: #28a745;
    background: #e8f5e9;
}

/* Conversations DataTable */
.conversations-table-wrapper {
    overflow-x: auto;
    margin-top: 15px;
}

.conversations-datatable {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.conversations-datatable th,
.conversations-datatable td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
}

.conversations-datatable th {
    background: #f5f5f5;
    font-weight: 600;
    color: #333;
    white-space: nowrap;
}

.conversations-datatable th.sortable {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.conversations-datatable th.sortable:hover {
    background: #e8e8e8;
}

.conversations-datatable tbody tr:hover {
    background: #f9f9f9;
}

.conversations-datatable .contact-cell .contact-name {
    font-weight: 500;
    color: #333;
}

.conversations-datatable .platform-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    color: white;
}

.conversations-datatable .platform-badge.whatsapp {
    background: #25D366;
}

.conversations-datatable .platform-badge.instagram {
    background: linear-gradient(45deg, #405DE6, #C13584, #F77737);
}

.conversations-datatable .platform-badge.instagram_dm {
    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);
}

.conversations-datatable .platform-badge.facebook {
    background: #1877F2;
}

.conversations-datatable .platform-badge.facebook_message {
    background: #0084FF;
}

.conversations-datatable .platform-badge.tiktok {
    background: #000;
}

.conversations-datatable .sentiment-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
}

.conversations-datatable .sentiment-badge.positive {
    background: #c8e6c9;
    color: #2E7D32;
}

.conversations-datatable .sentiment-badge.neutral {
    background: #fff9c4;
    color: #F57F17;
}

.conversations-datatable .sentiment-badge.negative {
    background: #ffcdd2;
    color: #C62828;
}

.conversations-datatable .message-count-cell {
    text-align: center;
    font-weight: 500;
}

.conversations-datatable .date-cell {
    font-size: 13px;
    color: #666;
    white-space: nowrap;
}

.conversations-datatable .escalated-badge {
    background: #FFF3E0;
    color: #E65100;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
}

.btn-view-detail {
    background: #007bff;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    transition: background 0.2s;
}

.btn-view-detail:hover {
    background: #0056b3;
}

/* Responsive DataTable */
@media (max-width: 768px) {
    .conversations-datatable {
        font-size: 12px;
    }

    .conversations-datatable th,
    .conversations-datatable td {
        padding: 8px 10px;
    }

    .btn-view-detail {
        padding: 4px 8px;
        font-size: 11px;
    }
}

/* No Data State for Charts */
.no-data-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
    color: #999;
}

.no-data-chart span {
    font-size: 48px;
    margin-bottom: 15px;
    opacity: 0.5;
}

.no-data-chart p {
    font-size: 16px;
    margin: 0;
}

/* ─── Social Engagement Grid ───────────────────────────────── */
.social-engagement-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    margin: 20px 0;
}

.social-metric-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 12px;
    border-radius: 12px;
    background: #f8f9fa;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.social-metric-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.social-metric-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin-bottom: 10px;
}

.social-metric-icon.comments-icon {
    background: linear-gradient(135deg, #ede9fe, #ddd6fe);
    color: #5b21b6;
}

.social-metric-icon.ai-icon {
    background: linear-gradient(135deg, #d1fae5, #a7f3d0);
    color: #065f46;
}

.social-metric-icon.unreplied-icon {
    background: linear-gradient(135deg, #ffedd5, #fed7aa);
    color: #9a3412;
}

.social-metric-icon.positive-icon {
    background: linear-gradient(135deg, #dcfce7, #bbf7d0);
    color: #166534;
}

.social-metric-icon.negative-icon {
    background: linear-gradient(135deg, #fee2e2, #fecaca);
    color: #991b1b;
}

.social-metric-icon.engagement-icon {
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
    color: #1e40af;
}

.social-metric-value {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
    line-height: 1.2;
}

.social-metric-label {
    font-size: 12px;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 4px;
    text-align: center;
}

/* ─── Comment Logs Section ─────────────────────────────────── */
.comment-logs-section {
    margin-top: 24px;
    border-top: 1px solid #e5e7eb;
    padding-top: 20px;
}

.comment-logs-section h4 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 16px 0;
    color: #333;
    font-size: 16px;
}

.comment-logs-section h4 i {
    color: #667eea;
}

.comment-logs-table .comment-text-cell {
    max-width: 250px;
}

.comment-preview {
    font-size: 13px;
    color: #374151;
    word-break: break-word;
}

.ai-response-preview {
    font-size: 13px;
    color: #059669;
    word-break: break-word;
}

.ai-response-preview i {
    margin-right: 4px;
    font-size: 12px;
}

.no-response {
    color: #9ca3af;
    font-style: italic;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.status-badge.replied {
    background: #d1fae5;
    color: #065f46;
}

.status-badge.pending {
    background: #fef3c7;
    color: #92400e;
}

.loading-small {
    padding: 20px;
    text-align: center;
    color: #6b7280;
}

/* Platform breakdown badges inside social metric cards */
.platform-breakdown {
    display: flex;
    gap: 6px;
    margin-top: 8px;
    flex-wrap: wrap;
    justify-content: center;
}

.platform-breakdown .platform-badge {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    color: white;
    font-weight: 500;
}

/* Comment logs table platform badges */
.comment-logs-table .platform-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    color: white;
    white-space: nowrap;
}

.comment-logs-table .platform-badge.instagram {
    background: linear-gradient(45deg, #405DE6, #C13584, #F77737);
}

.comment-logs-table .platform-badge.facebook {
    background: #1877F2;
}

.comment-logs-table .platform-badge.facebook_message {
    background: #0084FF;
}

.comment-logs-table .platform-badge.tiktok {
    background: #000;
}

@media (max-width: 1024px) {
    .social-engagement-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .social-engagement-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .comment-logs-table .comment-text-cell {
        max-width: 150px;
    }
}

/* ── Hot lead UI (ENGAGEMENT_REPLY_DM_SPLIT) ───────────────────────── */

.hot-leads-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    margin: 0.5rem 0 0.75rem 0;
    font-size: 0.9rem;
    color: #555;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.hot-leads-toggle input[type="checkbox"] {
    margin: 0;
    cursor: pointer;
}

.hot-lead-row {
    background-color: rgba(255, 140, 0, 0.06);
}

.hot-lead-badge {
    display: inline-block;
    margin-left: 0.4rem;
    padding: 0.1rem 0.45rem;
    background: #ff8c00;
    color: #fff;
    border-radius: 10px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    vertical-align: middle;
}

.hot-lead-contacts {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    margin-top: 0.25rem;
}

.hot-lead-contact-link {
    font-size: 0.8rem;
    color: #d47500;
    text-decoration: none;
}

.hot-lead-contact-link:hover {
    text-decoration: underline;
}

.comment-logs-table tbody tr.clickable-row {
    cursor: pointer;
    transition: background-color 0.12s ease;
}

.comment-logs-table tbody tr.clickable-row:hover {
    background-color: #f4f8ff;
}

.comment-logs-table tbody tr.clickable-row.hot-lead-row:hover {
    background-color: #fff3e0;
}

.comment-logs-table tbody tr.not-clickable-row {
    cursor: default;
    opacity: 0.78;
}`, "",{"version":3,"sources":["webpack://./src/components/AnalyticsDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,WAAW;AACX;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;;IAEI,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA,iEAAiE;AACjE;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,qDAAqD;IACrD,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA,iEAAiE;AACjE;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,yEAAyE;;AAEzE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,aAAa;AACjB","sourcesContent":[".analytics-dashboard {\n    padding: 20px;\n}\n\n/* Title with back button */\n.title-with-back {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.back-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: #666;\n}\n\n.back-button:hover {\n    background: #f0f0f0;\n    border-color: #007bff;\n    color: #007bff;\n}\n\n.back-button i {\n    font-size: 18px;\n}\n\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.time-range-selector button {\n    margin-left: 10px;\n    padding: 8px 16px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.time-range-selector button.active {\n    background: #007bff;\n    color: white;\n    border-color: #007bff;\n}\n\n/* Metrics Grid */\n.metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    margin-bottom: 30px;\n}\n\n.metric-card {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.metric-card h3 {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n    color: #666;\n    text-transform: uppercase;\n}\n\n.metric-value {\n    font-size: 36px;\n    font-weight: bold;\n    margin: 10px 0;\n}\n\n.metric-value.positive {\n    color: #4CAF50;\n}\n\n.metric-value.negative {\n    color: #F44336;\n}\n\n.metric-value.warning {\n    color: #FF9800;\n}\n\n.metric-label {\n    font-size: 12px;\n    color: #999;\n}\n\n/* Charts */\n.chart-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n    gap: 20px;\n    margin-bottom: 30px;\n}\n\n.chart-card {\n    min-height: 350px;\n}\n\n.chart-card h3 {\n    margin-top: 0;\n}\n\n/* Agent Performance */\n.agent-performance-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n/* Agent Type Selector */\n.agent-selector {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.agent-selector-btn {\n    padding: 10px 20px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.agent-selector-btn:hover {\n    background: #f0f0f0;\n    border-color: #007bff;\n}\n\n.agent-selector-btn.active {\n    background: #007bff;\n    color: white;\n    border-color: #007bff;\n}\n\n.agent-card {\n    background: #f8f9fa;\n    padding: 15px;\n    border-radius: 6px;\n    border-left: 4px solid #007bff;\n}\n\n.agent-card.no-data {\n    background: #f8f9fa;\n    border-left-color: #ccc;\n}\n\n.agent-card.no-data .no-data-message {\n    color: #888;\n    text-align: center;\n    padding: 20px 0;\n}\n\n.agent-card h4 {\n    margin: 0 0 15px 0;\n    text-transform: capitalize;\n}\n\n.agent-stats .stat {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n    font-size: 14px;\n}\n\n.stat-label {\n    color: #666;\n}\n\n.stat-value {\n    font-weight: bold;\n}\n\n.stat-value.positive {\n    color: #4CAF50;\n}\n\n.stat-value.negative {\n    color: #F44336;\n}\n\n.stat-value.warning {\n    color: #FF9800;\n}\n\n/* Social Stats */\n.social-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.stat-item {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.stat-item .label {\n    font-size: 14px;\n    color: #666;\n}\n\n.stat-item .value {\n    font-size: 24px;\n    font-weight: bold;\n}\n\n.stat-item .value.positive {\n    color: #4CAF50;\n}\n\n.stat-item .value.negative {\n    color: #F44336;\n}\n\n/* Daily Trends */\n.daily-trends {\n    margin-top: 20px;\n}\n\n.trend-row {\n    display: grid;\n    grid-template-columns: 120px 200px 1fr;\n    gap: 15px;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #eee;\n}\n\n.trend-row:last-child {\n    border-bottom: none;\n}\n\n.trend-row .date {\n    font-weight: 500;\n}\n\n.trend-metrics {\n    display: flex;\n    gap: 10px;\n}\n\n.trend-metrics span {\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.trend-metrics .positive {\n    background: #E8F5E9;\n    color: #2E7D32;\n}\n\n.trend-metrics .neutral {\n    background: #FFF9C4;\n    color: #F57F17;\n}\n\n.trend-metrics .negative {\n    background: #FFEBEE;\n    color: #C62828;\n}\n\n.trend-metrics .escalations {\n    background: #FFF3E0;\n    color: #E65100;\n}\n\n.trend-bar {\n    height: 20px;\n    display: flex;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.bar-segment {\n    height: 100%;\n}\n\n.bar-segment.positive {\n    background: #4CAF50;\n}\n\n.bar-segment.neutral {\n    background: #FFC107;\n}\n\n.bar-segment.negative {\n    background: #F44336;\n}\n\n/* Loading & Error States */\n.loading,\n.error {\n    text-align: center;\n    padding: 40px;\n    font-size: 18px;\n}\n\n.error {\n    color: #F44336;\n}\n\n/* Agent Logs Section */\n.agent-logs-section {\n    margin-top: 20px;\n    padding-top: 20px;\n    border-top: 1px solid #eee;\n}\n\n.agent-logs-section h4 {\n    margin-bottom: 15px;\n    text-transform: capitalize;\n}\n\n.no-logs {\n    text-align: center;\n    color: #999;\n    padding: 20px;\n}\n\n/* Conversation Cards */\n.conversation-card {\n    background: #f8f9fa;\n    border-radius: 8px;\n    margin-bottom: 10px;\n    overflow: hidden;\n    border: 1px solid #e0e0e0;\n}\n\n.conversation-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 15px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.conversation-header:hover {\n    background: #e9ecef;\n}\n\n.conversation-info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.contact-name {\n    font-weight: bold;\n    font-size: 15px;\n}\n\n.platform-badge {\n    background: #007bff;\n    color: white;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n    text-transform: uppercase;\n}\n\n.sentiment-badge {\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: bold;\n}\n\n.sentiment-badge.positive {\n    background: #E8F5E9;\n    color: #2E7D32;\n}\n\n.sentiment-badge.neutral {\n    background: #FFF9C4;\n    color: #F57F17;\n}\n\n.sentiment-badge.negative {\n    background: #FFEBEE;\n    color: #C62828;\n}\n\n.sentiment-badge.mixed {\n    background: #F3E5F5;\n    color: #7B1FA2;\n}\n\n.message-count {\n    color: #666;\n    font-size: 13px;\n}\n\n.conversation-meta {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.last-message-time {\n    color: #888;\n    font-size: 12px;\n}\n\n.escalated-badge {\n    background: #FFF3E0;\n    color: #E65100;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n}\n\n.expand-icon {\n    color: #888;\n    font-size: 12px;\n}\n\n/* Messages Container */\n.messages-container {\n    padding: 15px;\n    background: white;\n    border-top: 1px solid #e0e0e0;\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.message {\n    margin-bottom: 12px;\n    padding: 10px 15px;\n    border-radius: 8px;\n    max-width: 85%;\n}\n\n.message.inbound {\n    background: #e3f2fd;\n    margin-right: auto;\n    border-bottom-left-radius: 4px;\n}\n\n.message.outbound {\n    background: #f0f0f0;\n    margin-left: auto;\n    border-bottom-right-radius: 4px;\n}\n\n.message-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 5px;\n    font-size: 12px;\n}\n\n.message-direction {\n    font-weight: bold;\n}\n\n.message-time {\n    color: #888;\n}\n\n.sentiment-mini {\n    padding: 1px 6px;\n    border-radius: 8px;\n    font-size: 10px;\n}\n\n.sentiment-mini.positive {\n    background: #c8e6c9;\n    color: #2E7D32;\n}\n\n.sentiment-mini.neutral {\n    background: #fff9c4;\n    color: #F57F17;\n}\n\n.sentiment-mini.negative {\n    background: #ffcdd2;\n    color: #C62828;\n}\n\n.message-text {\n    font-size: 14px;\n    line-height: 1.4;\n    word-wrap: break-word;\n}\n\n.response-time {\n    font-size: 11px;\n    color: #888;\n    margin-top: 5px;\n}\n\n/* Selected Agent Card */\n.agent-card.selected {\n    border-left-color: #28a745;\n    background: #e8f5e9;\n}\n\n/* Conversations DataTable */\n.conversations-table-wrapper {\n    overflow-x: auto;\n    margin-top: 15px;\n}\n\n.conversations-datatable {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n}\n\n.conversations-datatable th,\n.conversations-datatable td {\n    padding: 12px 15px;\n    text-align: left;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.conversations-datatable th {\n    background: #f5f5f5;\n    font-weight: 600;\n    color: #333;\n    white-space: nowrap;\n}\n\n.conversations-datatable th.sortable {\n    cursor: pointer;\n    user-select: none;\n}\n\n.conversations-datatable th.sortable:hover {\n    background: #e8e8e8;\n}\n\n.conversations-datatable tbody tr:hover {\n    background: #f9f9f9;\n}\n\n.conversations-datatable .contact-cell .contact-name {\n    font-weight: 500;\n    color: #333;\n}\n\n.conversations-datatable .platform-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    color: white;\n}\n\n.conversations-datatable .platform-badge.whatsapp {\n    background: #25D366;\n}\n\n.conversations-datatable .platform-badge.instagram {\n    background: linear-gradient(45deg, #405DE6, #C13584, #F77737);\n}\n\n.conversations-datatable .platform-badge.instagram_dm {\n    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);\n}\n\n.conversations-datatable .platform-badge.facebook {\n    background: #1877F2;\n}\n\n.conversations-datatable .platform-badge.facebook_message {\n    background: #0084FF;\n}\n\n.conversations-datatable .platform-badge.tiktok {\n    background: #000;\n}\n\n.conversations-datatable .sentiment-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: capitalize;\n}\n\n.conversations-datatable .sentiment-badge.positive {\n    background: #c8e6c9;\n    color: #2E7D32;\n}\n\n.conversations-datatable .sentiment-badge.neutral {\n    background: #fff9c4;\n    color: #F57F17;\n}\n\n.conversations-datatable .sentiment-badge.negative {\n    background: #ffcdd2;\n    color: #C62828;\n}\n\n.conversations-datatable .message-count-cell {\n    text-align: center;\n    font-weight: 500;\n}\n\n.conversations-datatable .date-cell {\n    font-size: 13px;\n    color: #666;\n    white-space: nowrap;\n}\n\n.conversations-datatable .escalated-badge {\n    background: #FFF3E0;\n    color: #E65100;\n    padding: 4px 8px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.btn-view-detail {\n    background: #007bff;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    transition: background 0.2s;\n}\n\n.btn-view-detail:hover {\n    background: #0056b3;\n}\n\n/* Responsive DataTable */\n@media (max-width: 768px) {\n    .conversations-datatable {\n        font-size: 12px;\n    }\n\n    .conversations-datatable th,\n    .conversations-datatable td {\n        padding: 8px 10px;\n    }\n\n    .btn-view-detail {\n        padding: 4px 8px;\n        font-size: 11px;\n    }\n}\n\n/* No Data State for Charts */\n.no-data-chart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    color: #999;\n}\n\n.no-data-chart span {\n    font-size: 48px;\n    margin-bottom: 15px;\n    opacity: 0.5;\n}\n\n.no-data-chart p {\n    font-size: 16px;\n    margin: 0;\n}\n\n/* ─── Social Engagement Grid ───────────────────────────────── */\n.social-engagement-grid {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 16px;\n    margin: 20px 0;\n}\n\n.social-metric-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px 12px;\n    border-radius: 12px;\n    background: #f8f9fa;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.social-metric-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.social-metric-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n    margin-bottom: 10px;\n}\n\n.social-metric-icon.comments-icon {\n    background: linear-gradient(135deg, #ede9fe, #ddd6fe);\n    color: #5b21b6;\n}\n\n.social-metric-icon.ai-icon {\n    background: linear-gradient(135deg, #d1fae5, #a7f3d0);\n    color: #065f46;\n}\n\n.social-metric-icon.unreplied-icon {\n    background: linear-gradient(135deg, #ffedd5, #fed7aa);\n    color: #9a3412;\n}\n\n.social-metric-icon.positive-icon {\n    background: linear-gradient(135deg, #dcfce7, #bbf7d0);\n    color: #166534;\n}\n\n.social-metric-icon.negative-icon {\n    background: linear-gradient(135deg, #fee2e2, #fecaca);\n    color: #991b1b;\n}\n\n.social-metric-icon.engagement-icon {\n    background: linear-gradient(135deg, #dbeafe, #bfdbfe);\n    color: #1e40af;\n}\n\n.social-metric-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: #1f2937;\n    line-height: 1.2;\n}\n\n.social-metric-label {\n    font-size: 12px;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-top: 4px;\n    text-align: center;\n}\n\n/* ─── Comment Logs Section ─────────────────────────────────── */\n.comment-logs-section {\n    margin-top: 24px;\n    border-top: 1px solid #e5e7eb;\n    padding-top: 20px;\n}\n\n.comment-logs-section h4 {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 16px 0;\n    color: #333;\n    font-size: 16px;\n}\n\n.comment-logs-section h4 i {\n    color: #667eea;\n}\n\n.comment-logs-table .comment-text-cell {\n    max-width: 250px;\n}\n\n.comment-preview {\n    font-size: 13px;\n    color: #374151;\n    word-break: break-word;\n}\n\n.ai-response-preview {\n    font-size: 13px;\n    color: #059669;\n    word-break: break-word;\n}\n\n.ai-response-preview i {\n    margin-right: 4px;\n    font-size: 12px;\n}\n\n.no-response {\n    color: #9ca3af;\n    font-style: italic;\n}\n\n.status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.status-badge.replied {\n    background: #d1fae5;\n    color: #065f46;\n}\n\n.status-badge.pending {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.loading-small {\n    padding: 20px;\n    text-align: center;\n    color: #6b7280;\n}\n\n/* Platform breakdown badges inside social metric cards */\n.platform-breakdown {\n    display: flex;\n    gap: 6px;\n    margin-top: 8px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.platform-breakdown .platform-badge {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    color: white;\n    font-weight: 500;\n}\n\n/* Comment logs table platform badges */\n.comment-logs-table .platform-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 500;\n    color: white;\n    white-space: nowrap;\n}\n\n.comment-logs-table .platform-badge.instagram {\n    background: linear-gradient(45deg, #405DE6, #C13584, #F77737);\n}\n\n.comment-logs-table .platform-badge.facebook {\n    background: #1877F2;\n}\n\n.comment-logs-table .platform-badge.facebook_message {\n    background: #0084FF;\n}\n\n.comment-logs-table .platform-badge.tiktok {\n    background: #000;\n}\n\n@media (max-width: 1024px) {\n    .social-engagement-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .social-engagement-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .comment-logs-table .comment-text-cell {\n        max-width: 150px;\n    }\n}\n\n/* ── Hot lead UI (ENGAGEMENT_REPLY_DM_SPLIT) ───────────────────────── */\n\n.hot-leads-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin: 0.5rem 0 0.75rem 0;\n    font-size: 0.9rem;\n    color: #555;\n    cursor: pointer;\n    user-select: none;\n}\n\n.hot-leads-toggle input[type=\"checkbox\"] {\n    margin: 0;\n    cursor: pointer;\n}\n\n.hot-lead-row {\n    background-color: rgba(255, 140, 0, 0.06);\n}\n\n.hot-lead-badge {\n    display: inline-block;\n    margin-left: 0.4rem;\n    padding: 0.1rem 0.45rem;\n    background: #ff8c00;\n    color: #fff;\n    border-radius: 10px;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    vertical-align: middle;\n}\n\n.hot-lead-contacts {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    margin-top: 0.25rem;\n}\n\n.hot-lead-contact-link {\n    font-size: 0.8rem;\n    color: #d47500;\n    text-decoration: none;\n}\n\n.hot-lead-contact-link:hover {\n    text-decoration: underline;\n}\n\n.comment-logs-table tbody tr.clickable-row {\n    cursor: pointer;\n    transition: background-color 0.12s ease;\n}\n\n.comment-logs-table tbody tr.clickable-row:hover {\n    background-color: #f4f8ff;\n}\n\n.comment-logs-table tbody tr.clickable-row.hot-lead-row:hover {\n    background-color: #fff3e0;\n}\n\n.comment-logs-table tbody tr.not-clickable-row {\n    cursor: default;\n    opacity: 0.78;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
